import { createSelector } from 'reselect';

// Selectors
import { getMaintenanceServices } from 'store/reducers/maintenance/selectors';
import { getRepairServices } from 'store/reducers/repair/selectors';
import { getGlobalRepairServices } from 'store/reducers/globalRepair/selectors';
import { getPromotionServices } from 'store/reducers/appointment/selectors';

// Utils
import { applyPromotionToService } from 'utils/promotions';

export const getIndividualServices = createSelector(
  getMaintenanceServices,
  getRepairServices,
  getGlobalRepairServices,
  getPromotionServices,
  (maintenance, repair, globalRepair, promotionServices) => {
    const allIndividual = [...maintenance, ...repair, ...globalRepair].sort(
      (a, b) => {
        const inf = 1000000;
        return (a.rank || inf) - (b.rank || inf);
      }
    );
    if (promotionServices) {
      return applyPromotionToService(promotionServices, allIndividual);
    } else {
      return allIndividual;
    }
  }
);

export const getMostCommonServices = createSelector(
  getIndividualServices,
  individualServices => individualServices.slice(0, 5)
);

export const getAllServices = createSelector(
  getIndividualServices,
  individualServices => individualServices.slice(5)
);



// WEBPACK FOOTER //
// ./src/store/reducers/individualServices/selectors.js